module.exports = __webpack_public_path__ + "img/hero.25e8663f.jpg";